
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

  @Component
  export default class General extends Vue  {
    dialog = false
    editDateMenu = false
    expanded = []
    headers = [
      {
        text: 'Date',
        align: 'start',
        value: 'date',
      },
      { text: 'Item', value: 'item' },
      { text: 'Measurement', value: 'measurement' },
      { text: 'Cost', value: 'itemCost' },
      { text: 'Number of Units', value: 'numOfUnits' },
      { text: 'Total', value: "test" },
      { text: 'Actions', value: 'actions', sortable: false },
    ]

    measurement: any = [
      { text: 'LF', value: 'LF' },
      { text: 'CF', value: 'CF' },
      { text: 'CY', value: 'CY' },
      { text: 'SF', value: 'SF' },
      { text: 'EA', value: 'EA' },
      { text: 'LS', value: 'LS' },
      { text: 'Gal Ton', value: 'Gal Ton' },
    ]

    items: any = []
    editedIndex = -1
    editedItem: any = {
      id: null,
      date: new Date().toISOString().substr(0, 10),
      item: 0,
      itemCost: 0,
      measurement: '',
      numOfUnits: 0,
      notes: '',
      bridgeId: -1
    }
    defaultItem: any = {
      id: null,
      date: new Date().toISOString().substr(0, 10),
      item: '',
      itemCost: 0,
      measurement: '',
      numOfUnits: 0,
      notes: '',
      bridgeId: -1
    }

    @Prop() readonly id!: object
    @Prop() readonly tab!: number

    //Methods
    public sumField(key: any): any {
      return this.items.reduce((a: any, b: any ) => (Number(a) + (Number(b[key]) || 0)), 0)
    }

    public editItem(item: object ): void {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    }

    public close(): void {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    }

    public deleteItem(item: object): void {
      confirm('Are you sure you want to delete this item?') && this.$store.dispatch('bridge/deleteMaintenanceCost', item)
    }

    public save(): void {
      this.editedItem.bridgeId = this.id
      if (this.editedIndex > -1) {
        this.$store.dispatch('bridge/updateMaintenanceCost', this.editedItem)
        //Object.assign(this.items[this.editedIndex], this.editedItem)
      } else {
        this.$store.dispatch('bridge/storeMaintenanceCost', this.editedItem)
        //this.items.push(this.editedItem)
      }
      this.close()
    }

    //Getters
    get totals(): any {
      let total = 0
      this.items.forEach( (element: any) => {
        total += (Number(element.itemCost) * Number(element.numOfUnits))
      })
      return total
    }
    get getBridgeMaintenanceCosts(): any {
      return this.$store.getters['bridge/getBridgeMaintenanceCosts']
    }
    get getReload(): boolean {
      return this.$store.getters['bridge/getReload']
    }
    get getLoading(): boolean {
      return this.$store.getters['bridge/getLoading']
    }
    get getMessage(): string {
      return this.$store.getters['bridge/getMsg']
    }
    get getErrors(): Array<string> {
      return this.$store.getters['bridge/getErrors']
    }
    get getDeletePermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }
    get getEditPermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Editor') ||
              this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }

    //Watchers
    @Watch('getReload')
    reload(val: boolean) {
      if(val && this.tab == 1) {
        this.$store.dispatch('bridge/getMaintenanceCosts', { id: this.id })
        this.$store.commit('bridge/setReload', false)
      }
    }
    @Watch('getBridgeMaintenanceCosts')
    setItems(val: any) {
      this.items = val
    }
  }



